import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";

//ASSETS
import Logo from "../assets/nectar-logo.svg";

const navigation =[
  {
    href: "/business-advisory",
    title: "Business Advisory"
  },
  {
    href: "/investment-acquisition",
    title: "Investment & Acquistion"
  },
  {
    href: "/payroll",
    title: "Payroll"
  },
  {
    href: "/hr-solutions",
    title: "HR Solutions"
  },
]

const Navbar = ({refNavbar}) => {

  return (
    <Popover className="relative bg-darkBlue text-body">
      <div ref={refNavbar} className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-rows-1 items-center pt-8 pb-6 md:grid-cols-1 md:grid-rows-2">
          <div className="flex items-center justify-between md:justify-center w-full">
            <Link to="/">
              <span className="sr-only">Nectar Consulting</span>
              <img
                className="h-16 mx-auto w-auto sm:h-20"
                src={Logo}
                alt="Nectar Consulting"
              />
            </Link>
            <div className="md:hidden">
              <Popover.Button className="text-white">
                <span className="sr-only">Open menu</span>
                <MenuIcon className="h-8 w-8" aria-hidden="true" />
              </Popover.Button>
            </div>
          </div>

          <nav className="hidden md:flex justify-center mt-4">
            <div className="flex justify-between items-center space-x-10 text-lightGrey">
              {navigation.map(item => (
                <Link
                  key={item.title}
                  to={item.href}
                  className="text-base font-medium hover:text-white"
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </nav>
        </div>
      </div>

      <Transition
      as={Fragment}
      enter="duration-200 ease-out"
      enterFrom="opacity-0 scale-95"
      enterTo="opacity-100 scale-100"
      leave="duration-100 ease-in"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
        focus
        className="z-10 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
        >
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-darkBlue">
            <div className="pt-4 px-5 flex items-center justify-between">
              <div>
                <img
                  className="h-16 w-auto"
                  src={Logo}
                  alt="Nectar Consulting"
                />
              </div>
              <div className="-mr-2 flex">
                <Popover.Button className="p-2 text-lightGrey hover:text-white">
                  <span className="sr-only">Close menu</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </Popover.Button>
              </div>
            </div>

            <div className="py-4 px-5 space-y-6">
              <div className="flex flex-col space-y-4 text-lightGrey">
                {navigation.map(item => (
                  <Popover.Button key={item.title}>
                    <Link
                      to={item.href}
                      className="text-base font-medium hover:text-white"
                    >
                      {item.title}
                    </Link>
                  </Popover.Button>
                ))}
              </div>
              <div className="flex justify-center w-full bg-earth rounded-md shadow-md py-2">
                <Popover.Button>
                  <Link
                    to="/contact"
                    className="whitespace-nowrap text-base font-medium text-white"
                  >
                    Let's talk
                  </Link>
                </Popover.Button>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default Navbar;
